<template>
  <div id="Login" class="layout-login">
    <v-row align="center" justify="center"
      ><v-col cols="12">
        <v-card color="primary" max-width="700" class="pa-4" dark
          ><v-card-text
            ><v-row align="stretch" justify="center"
              ><v-col cols="6">
                <div class="layout-btn">
                  <h1 class="text-h4 mb-4">GULF VENDOR PORTAL</h1>
                  <p>Gulf Development Public Company Limited</p>
                  <div class="card-btn">
                    <v-card
                      color="#304765"
                      class="icon-btn mr-4"
                      @click="gotoPage('vendorguide')"
                      ><v-card-text>
                        <v-icon color="secondary" x-large dark
                          >mdi-book-open-page-variant-outline</v-icon
                        >
                        <p class="mt-3">Vendor Guide</p>
                      </v-card-text></v-card
                    >
                    <v-card
                      color="#304765"
                      class="icon-btn"
                      @click="gotoPage('announcement')"
                      ><v-card-text>
                        <v-icon color="secondary" x-large dark
                          >mdi-bullhorn</v-icon
                        >
                        <p class="mt-3">Announcement</p>
                      </v-card-text></v-card
                    >
                  </div>
                </div> </v-col
              ><v-col cols="6">
                <v-card color="#304765"
                  ><v-card-text
                    ><h1 class="text-h5 mb-4">Login</h1>
                    <v-form ref="form" v-model="valid" lazy-validation>
                      <v-text-field
                        light
                        solo
                        dense
                        v-model="email"
                        :counter="18"
                        :maxlength="18"
                        :rules="[
                          (v) => !v ? 'Username is required' : /^\d+$/.test(v) || 'Username must be numeric',
                        ]"
                        label="Username"
                        required
                      ></v-text-field>

                      <v-text-field
                        light
                        solo
                        dense
                        v-model="password"
                        label="Password"
                        required
                        :type="'password'"
                        :rules="[(v) => !!v || 'Password  is required']"
                      ></v-text-field
                      ><v-btn color="#0B1D35" class="mr-4" @click="login" block>
                        Login
                      </v-btn>
                    </v-form>
                    <div class="text-center mt-4">
                      Not registered yet ?
                      <a class="secondary--text" @click="gotoPage('register')"
                        >Register
                      </a>
                      <br />
                      <a
                        class="secondary--text"
                        @click="gotoPage('forgotpassword')"
                        >Forgot Password
                      </a>
                    </div></v-card-text
                  ></v-card
                ></v-col
              ></v-row
            ></v-card-text
          ></v-card
        ></v-col
      ></v-row
    >
    <v-dialog v-model="dialog" width="500" persistent>
      <v-card>
        <v-card-title class="grey lighten-2">
          Account Lock.
        </v-card-title>
        <v-card-text class="mt-4">
          Your account was locked because your attempt many times, Please contact Gulf procurement to unlock.
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="unlock" :loading="loading">Request unlock</v-btn>
          <v-btn color="primary" text @click="dialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { vendorservice } from "../services/vendorservice";
export default {
  name: "Login",
  data: () => ({
    email: "",
    password: "",
    dialog: false,
    valid: true,
    loading: false,
  }),
  methods: {
    async login() {
      await this.$refs.form.validate();
      // Authen template //
      let userName = this.email;
      let password = this.password;
      // console.log(this.$store.state.status);

      if (this.valid === true) {
        this.$loading(true);
        this.$store
          .dispatch("login", { userName, password })
          .then(() => {
            if (this.$store.state.message) {
              this.$notify({
                type: "error",
                title: "Login failed!",
                text: `${this.$store.state.message}`,
              });
              if (/^Your account was locked/.test(this.$store.state.message)) {
                this.dialog = true;
              }
            }
            this.$loading(false);
          })
          .catch((err) => console.log(err));
      }
    },
    gotoPage(page) {
      this.$router.push(`/${this.$i18n.locale}/${page}`).catch(() => {});
    },
    async unlock() {
      this.$loading(true);
      this.loading = true;
      let response = await vendorservice.RequestUnlock(this.email);
      if (response) {
        this.$notify({
          title: "Send email success",
          text: "Please wait for our staff to contact you.",
          type: "success",
        });
        // Redirect to login page
        this.dialog = false;
      } else {
        this.$notify({
          title: "Send email failed",
          text: "Please try again later or using a different method.",
          type: "error",
        });
      }

      this.loading = false;
      this.$loading(false);
    },
  },
};
</script>

<style lang="scss" scoped>
.layout-login {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  > .image {
    height: 100vh;
    position: fixed;
    top: 0;
  }
  > .image-logo {
    position: fixed;
    width: 150px;
    top: 3rem;
    left: 3rem;
  }
}
.icon-btn {
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-content: center;
  text-align: center;
  width: 100%;
}
.card-btn {
  margin-top: auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.layout-btn {
  display: flex;
  flex-direction: column;
  height: 100%;
}
</style>
